<template>
  <div id="app">
    <div id="appInner">
      <router-view></router-view>
    </div>
    <div class="usertx">
          <div class="usertxbackground" v-for="(item,index) in infor" :key="index" @click="current(item.id)">
            <p class="usertxp1"><a>{{item.name}}</a><span>{{item.time}}</span></p>
            <p class="usertxp2" >{{item.content}}</p>
            <span class="userno" @click.stop="delinfor(item.id)"></span>
          </div>
      </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'app',
  computed: {
      ...mapGetters({
        infor: 'inforchange',
      })
    },
  data() {
    return {
      beforeUnloadTime: 0,
      unloadTime: 0,
      homeType: 0
    }
  },
  mounted(){
    this.homeType = sessionStorage.getItem('redirectTarget')
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.removeEventListener('unload', e => this.unloadHandler(e))
  },
  methods: {
    beforeunloadHandler(){
      this.beforeUnloadTime=new Date().getTime();
    },
    unloadHandler(e){
      this.unloadTime=new Date().getTime()-this.beforeUnloadTime;
      //判断是窗口关闭还是刷新，如果是关闭
      if(this.unloadTime<=5 && this.homeType == 5){
        this.$Points.point({code: '1006'})
      }
    },
    current(id){
       window.location.href="#/imSession";
    },
    delinfor(id){
      var nowindex=0;
      console.log(this.$store.state.im.infor)
      this.$store.state.im.infor.forEach(function(element, index) {
        if(element.id==id){
          nowindex=index;
        }
      });
      this.$store.state.im.infor.splice(nowindex,1)
    },
  },
}
</script>

<style>
ul,li,div,body,html,img,i,b,a,ol,span,p,em,h1,h2,h3,h4,h5,h6{ padding: 0; margin: 0;}
a{text-decoration:none;}
img{ border: 0;}
#app {

  background: #eef3fa;
  height: 100vh;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}
#appInner{
  background: #ffffff;
}
#appInner{
  background: #f8f8f8;
  width: 640px;
  height: 620px;
  overflow: hidden;
  position:absolute;
   left:50%;
   z-index: 1;
   top:50%;
   margin:-310px 0 0 -320px;
}
.loginMobile .el-input-group__append{
  padding: 0;
}
.loginMobile .el-input-group__append a{
  height: 34px;
  line-height: 34px;
  text-align: center;
  border-radius: 0 3px 3px 0;
}
.usertx{
    position:fixed;
    width:340px;
    right:0px;
    bottom:0px;
    z-index:100000000;
  }
  .usertxbackground{
    width:306px;
    height:106px;
    overflow:hidden;
    position:relative;
    background:url('/pc/static/assets/usertx.png') no-repeat left top;
  }
  .usertxbackground p{
    margin-left:95px;
    width:180px;
  }
  .usertxbackground .usertxp1{
    margin-top:28px;
  }
  .usertxbackground .usertxp1 a{
    font-size:16px;
    color:#333;
    float:left;
    width:80px;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
  }
  .usertxbackground .usertxp1 span{
    font-size:14px;
    color:#999;
    float:right;
  }
  .usertxbackground .usertxp2{
    clear:both;
    font-size:14px;
    color:#666;
    padding-top:6px;
    width:180px;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
    cursor:pointer;
  }
  .userno{
    display:block;
    width:20px;
    height:20px;
    position:absolute;
    top:10px;
    right:10px;
    cursor:pointer;
    background:url('/pc/static/assets/usertxno.png') no-repeat left top;
  }
  .userno:hover{
    background:url('/pc/static/assets/usertxnog.png') no-repeat left top;
  }
  .spirit .sessionDiv a  {
    text-decoration: underline;
    color: #5987c2;
  }
  .spirit table {
    width: 100% !important;
  }
  .workerorderindex {
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue?51cde765